import { isArray, isNumber, isObject, toNumber } from "lodash";
import { useHintCardStore } from "@/src/stores/useHintCardStore";
import { useEffect, useMemo } from "react";
import { ProposalTable as ProposalTableUI } from "./ProposalTable";
import { useFormContext } from "react-hook-form";
import { DAYS_ABROAD_CONST, isVisaCentreCategory, ProposalTableColumnsKeys } from "../lib/const";

export function ProposalTable(props: any) {
  const columns = isArray(props?.columns) ? props.columns : [];
  const rows = isArray(props?.rows) ? props.rows : [];
  const pdfFile = isObject(props?.pdfFile) ? props.pdfFile : {};
  const hidden = !!props?.hidden;

  const setHintsList = useHintCardStore((state) => state.setHintsList);
  const { watch } = useFormContext();

  const watchedDaysAbroad = watch(DAYS_ABROAD_CONST);

  useEffect(() => {
    const hintList = rows.reduce((acc: any, item: any) => {
      if (item?.hint) {
        acc.push({ ...item.hint, contentTitle: item?.title });
      }
      return acc;
    }, []);
    setHintsList(hintList);
  }, [rows, setHintsList]);

  const filteredColumns = useMemo(() => {
    // The days-abroad-based Standart/Prestige narrowing only applies to base Tourism; Visa Centre
    // always shows both franchise cards regardless of trip length.
    if (columns.some((col: any) => isVisaCentreCategory(col?.title))) {
      return columns;
    }

    const daysAbroadValue = toNumber(watchedDaysAbroad);
    if (!isNumber(daysAbroadValue)) {
      return columns;
    }

    return columns.filter((col: any) => {
      if (daysAbroadValue <= 2) {
          return ( col.title === ProposalTableColumnsKeys.Prestige );
      }
      else if (daysAbroadValue <= 356) {
          return [ProposalTableColumnsKeys.Prestige, ProposalTableColumnsKeys.Standard].includes(col.title);
      }

      return true;
    });
  }, [columns, watchedDaysAbroad]);

  return (
    <ProposalTableUI
      pdfFile={pdfFile}
      hidden={hidden}
      columns={filteredColumns}
      rows={rows}
      columnName={"pickedTravelCalculationCategory"}
    />
  );
}
